<div class="paginate-page-select">
  <div  class="inline-label">
    <label class="TablesTable-Header">{{'paginate_items_per_page'| translation}}:</label>
    <nb-select
      [(ngModel)]="perPage"
      [placeholder]="'paginate_per_page'| translation"
      (selectedChange)="setPageCount()"
    >
      <nb-option
        class="ppo"
        *ngFor="let option of perPageOptions"
        [value]="option.count"
        >{{ option.count }}</nb-option
      >
    </nb-select>
  </div>
  <div style="flex:1 1 auto;"></div>
  <div class="paginate-page-select-count-label" *ngIf="countLabel">
    {{ countLabel }}
  </div>
</div>
